import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Place, PlaceCategory, VerificationStatus, KosherStatus } from '@/types/places';

export const usePlaceDetails = (placeId: string | null) => {
  return useQuery({
    queryKey: ['place', placeId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('places')
        .select('*')
        .eq('id', placeId!)
        .maybeSingle();

      if (error) throw error;
      if (!data) return null;

      // Transform to Place type
      const place: Place = {
        id: data.id,
        name: data.name,
        category: data.category as PlaceCategory,
        lat: data.lat,
        lng: data.lng,
        address: data.address,
        city: data.city,
        country: data.country,
        postalCode: data.postal_code || undefined,
        photos: data.photos || [],
        kosherStatus: data.kosher_status as KosherStatus | undefined,
        kosherAuthority: data.kosher_authority || undefined,
        openingHours: data.opening_hours as Place['openingHours'],
        phone: data.phone || undefined,
        website: data.website || undefined,
        email: data.email || undefined,
        instagram: data.instagram || undefined,
        facebook: data.facebook || undefined,
        description: data.description || undefined,
        verificationStatus: data.verification_status as VerificationStatus,
        distance: undefined,
        createdAt: data.created_at,
        updatedAt: data.updated_at,
        createdBy: data.created_by || undefined,
        promotedRank: data.promoted_rank || undefined,
        rating: data.rating ? Number(data.rating) : undefined,
        reviewCount: data.review_count || undefined,
        priceRange: data.price_range || undefined,
      };

      return place;
    },
    enabled: !!placeId,
  });
};
